var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row center align-items-center"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"mb-4"},[_vm._v(" "+_vm._s(_vm.$t('pages.complete.title'))+" ")]),_c('h4',[_vm._v(_vm._s(_vm.$t('pages.complete.thank_you_for_submitting')))]),_c('h6',{},[_vm._v(_vm._s(_vm.$t('pages.complete.data_submitted')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }